import React, { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { api } from "@/redux/api";
import { useAuthEditable } from "@/hooks/use-auth";
import { buildPortfolioPath } from "@/utils/route-context";
import ContractDetail from "@/containers/contract/ContractDetail";

export default function PortfolioContractDetailPage() {
  const { companyId, id } = useParams();
  const location = useLocation();
  const canAddNote = useAuthEditable("contract");
  const baseListPath = buildPortfolioPath("contract-request", { companyId }) || "/switch-view";
  const listPath = `${baseListPath}${location.search || ""}`;

  const loadRequest = useCallback(
    (requestId) => api.getContract(requestId),
    []
  );
  const addNote = useCallback(
    (requestId, content) => api.addContractNote(requestId, content),
    []
  );

  return (
    <ContractDetail
      role="portfolio"
      requestId={id}
      listPath={listPath}
      loadRequest={loadRequest}
      addNote={addNote}
      canAddNote={canAddNote}
      closeContract={api.closeContract}
    />
  );
}
